import React, { useEffect, useState } from 'react';
import moment from 'moment';
import styles from './CalculatorCalculation.module.scss';
import { currency } from '../../../utils/dashboard-utils';
import MyToolTip from '../../Shared/MyToolTip/MyToolTip';
import DatePickerBeacon from '../../Beacon/DatePickerBeacon';
import { RMDBeaconInputField } from '../../Beacon/RMDBeaconInputField';
import plusBeacon from '../../../assets/images/icon-button-beacon-plus-button.png';
import beaconMinus from '../../../assets/images/icon-button-beacon-minus-button.png';
import chevronDown from '../../../assets/images/chevronDown.png';
import chevronUp from '../../../assets/images/chevronUp.png';
import {
  ESTIMATED_RATE_OF_RETURN,
  RMD_PRIOR_YEAR_UNAVAILABLE,
  openModal as openModalAction,
} from '../../../redux/modules/modals/modals.module';
import * as moduleActions from '../../../redux/modules/RMD/RMD.module';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Loader/Loader';
import { resetRMDCalc } from '../../../redux/modules/RMD/RMD.module';
import { currentYear, userTurnsRMDEligible } from '../../../utils/date-utils';
import { RMDBeaconControl } from '../../Beacon/RMDBeaconControl';

const CalculatorCalculation = ({ selectedYear = '' }) => {
  //var year = new Date().getFullYear()
  const dispatch = useDispatch();
  const rmdDistribution = useSelector(
    (state) => state.RMDSetting.rmdMinimumDistribution
  );
  rmdDistribution?.sort((a, b) => a?.distributionYear - b?.distributionYear);

  const isRMDCalculatorLoading = useSelector(
    (state) => state.RMDSetting.isRMDCalculatorLoading
  );
  const DEFAULT_TRIGGER = (
    <p className={styles['rmd-calculated']}>How is my RMD calculated?</p>
  );
  const rmd_years = [
    { value: 'Current', label: 'Current' },
    { value: 'Prior', label: 'Prior' },
  ];

  const [spouseBeneficiary, setSpouseBeneficiary] = useState(false);
  const [amount, setAmount] = useState(0);
  const [isValidRate, setIsValidRate] = useState(true);
  const [accountAsOf, setAccountAsOf] = useState('0.00');
  const [state, setState] = useState(selectedYear);
  const [isAcknowledge, setIsAcknowledge] = useState(false);
  const [curDistributionType, setCurDistributionType] = useState('');

  const [Dob, setDob] = useState(null);
  const [spouseDOB, setSpouseDOB] = useState(null);

  const [disabledBtn, setdisabledBtn] = useState(true);
  const [showProjection, setShowProjection] = useState(false);
  const [showRMDCalc, setShowRMDCalc] = useState(false);
  const curDate = new Date();

  const isYearTurningRMDEligible = userTurnsRMDEligible(Dob) >= currentYear('YYYY');
  useEffect(() => {
    setSpouseDOB(spouseDOB);
  }, [spouseDOB]);
  useEffect(() => {
    setdisabledBtn(
      !(
        Dob &&
        state &&
        isAcknowledge &&
        Number(accountAsOf?.replace(/,/g, '')) > 0
      )
    );
  }, [Dob, state, isAcknowledge, accountAsOf]);

  const resetData = () => {
    setState('');
    setDob(null);
    setIsAcknowledge(false);
    setAccountAsOf(null);
    setAmount(0);
    setIsValidRate(true);
    setSpouseBeneficiary(false);
    setdisabledBtn(true);
    dispatch(resetRMDCalc());
    setShowRMDCalc(false);
    setCurDistributionType('');
  };
  const calculateMyRMd = () => {
    setShowRMDCalc(true);
    setIsAcknowledge(false);
    setdisabledBtn(true);
    setShowProjection(true);
    setCurDistributionType(state);
    const temp = Dob.split('-');
    const tempDob = new Date();
    let tempSpouseDob = null;
    tempDob.setFullYear(temp[0], temp[1] - 1, temp[2]);
    if (spouseBeneficiary) {
      const temp2 = spouseDOB.split('-');
      tempSpouseDob = new Date();
      tempSpouseDob.setFullYear(temp2[0], temp2[1] - 1, temp2[2]);
    }
    const payload = {
      ownerDateOfBirth: tempDob,
      spouseDateOfBirth: spouseBeneficiary ? tempSpouseDob : null,
      beneficiaryType: spouseBeneficiary ? 3 : tempSpouseDob ? 2 : 1,
      accountBalance: parseFloat(Number(accountAsOf?.replace(/,/g, ''))),
      calculateExactAgeAtEndOfYear: true,
      projectionForNumberOfYears: 5,
      rateOfReturn: parseFloat(amount),
    };

    if (state !== 'Current') {
      const tempDate = new Date().getFullYear() - 1;
      payload.distributionYear = tempDate;
    }
    const unavailablePriorRMD = isYearTurningRMDEligible && state === 'Prior';

    if(unavailablePriorRMD) {
      setShowRMDCalc(false);
      setShowProjection(false);
      dispatch(openModalAction(RMD_PRIOR_YEAR_UNAVAILABLE))
    }
    else {
      dispatch(moduleActions.getRmdMinimumDistribution(payload));
    }
  };

  if (isRMDCalculatorLoading) {
    return <Loader isVisible={true} />;
  }
  return (
    <div className={styles['container']}>
      <div className={styles['rmd-year']}>
        <div className={"beacon-theme-modern-outlook"}>
          <RMDBeaconControl>
            <label className="b-typography-sans-serif--caption--100 b-font-weight-bold" slot="label" htmlFor="distributionYear">Select Distribution Year</label>
            <select
                onChange={(e) => {
                  setShowProjection(curDistributionType !== 'Prior');
                  setState(e.target.value);
                  setAmount(e.target.value === 'Current' ? 5.5 : amount);
                }}
                value={state}
                id="distributionYear">
              required
              <option key="default" disabled value="" defaultValue={''}/>
              {rmd_years.map((option) => (
                  <option value={option.value} key={`${option.value}-dDistributionYear`}>
                    {option.label}
                  </option>
              ))}
            </select>
            <div slot="error">Relationship is required</div>
          </RMDBeaconControl>
        </div>
        <div className={styles['date-picker']}>
          <DatePickerBeacon
            value={Dob}
            label="Your Date of Birth"
            name="Your Date of Birth"
            id="beacon-date-of-birth"
            handleChange={(e) => {
              setDob(e.target.value);
            }}
          />
        </div>
        <div className={styles['date-picker']}>
          <label className={styles['primary-bene']}>
            Is your spouse the sole primary beneficiary?
          </label>
          <div className={styles['radio-button-container']}>
            <input
              name="Yes"
              type={'radio'}
              className={styles['radio-buttons-yes']}
              required={false}
              onClick={() => setSpouseBeneficiary(true)}
              checked={spouseBeneficiary}
              //handleRadioChange={() => setSpouseBeneficiary(true)}
              //handleRadioInput={() => setSpouseBeneficiary(true)}
              value={true}
              label="Yes"
              aria-label="radio-button-yes"
            />
            <label className={styles['radio-buttons-yes-text']}> Yes</label>
          </div>
          <div className={styles['radio-button-container']}>
            <input
              label="No"
              name="No"
              type={'radio'}
              className={styles['radio-buttons-yes']}
              required={false}
              checked={!spouseBeneficiary}
              onClick={() => setSpouseBeneficiary(false)}
              //handleRadioChange={() => setSpouseBeneficiary(false)}
              value={false}
              aria-label="radio-button-no"
            />
            <label className={styles['radio-buttons-yes-text']}> No</label>
          </div>
          {spouseBeneficiary && (
            <div className={styles['date-picker-spouse']}>
              <DatePickerBeacon
                value={spouseDOB}
                max={
                  spouseBeneficiary &&
                  moment(
                    new Date(
                      curDate.getFullYear() - 18,
                      curDate.getMonth(),
                      curDate.getDate()
                    )
                  ).format('YYYY-MM-DD')
                }
                label="Your Spouse’s Date of Birth"
                name="Spouse’s Date of Birth"
                id="spouse-date-of-birth"
                errorsMap='{"min": "CCCCC", "max": "SDFDSF"}'
                handleChange={(e) => {
                  setSpouseDOB(e.target.value);
                }}
              />
            </div>
          )}
        </div>
        <div className={styles['amount-input']}>
          {/*<RMDBeaconInputField*/}
          {/*  label="Account Balance as of 12/31"*/}
          {/*  name="Account Balance as of 12/31"*/}
          {/*  hint="Be sure to adjust this balance to include any pending transfers or rollovers into this account."*/}
          {/*  type="text"*/}
          {/*  format=""*/}
          {/*  pattern={/^$|^([0-9#.,]+)$/i}*/}
          {/*/>*/}
          <label className={styles['primary-bene']}>
            Account Balance as of 12/31*
            <RMDBeaconInputField
              className={styles['rmd-input-banner']}
              id="beacon-accountAsOf-input-filed"
              label=""
              format="^(\d+,*)*\.?\d{0,2}$"
              formatType="regexp"
              value={accountAsOf}
              name="beacon-accountAsOf"
              required={true}
              onBeaconInput={(e) => {
                const { target } = e;
                document.getElementById(target.id).evaluateValidations();
                setAccountAsOf(target.value);
              }}
            />
          </label>
        </div>
        {state === 'Current' && (
          <div className={styles['estimated-return-on-date']}>
            <label className={styles['primary-bene']}>
              Estimated{' '}
              <button
                onClick={() =>
                  dispatch(openModalAction(ESTIMATED_RATE_OF_RETURN))
                }
                className={styles['rate-of-return-header']}
              >
                Rate of Return
              </button>
            </label>
            <p className={styles['rate-of-return-text']}>
              This percentage is used to estimate your future RMDs. If you’re
              not sure what your rate is, consider using the default rate
              provided.
            </p>

            <div className={styles['rate-of-return']}>
              <button
                className={
                  isValidRate
                    ? styles['clickable-button']
                    : styles['clickable-button-2']
                }
                onClick={() => {
                  let num = parseFloat(amount) - 0.5;
                  if (num < 0) num = '0';
                  setAmount(num.toString());
                }}
              >
                <img
                  className={styles['lock-img']}
                  alt="minusBeacon"
                  src={beaconMinus}
                />
              </button>
              <label className={styles['label-ommit']}>
                Rate Of Return Input
                <RMDBeaconInputField
                  type="number"
                  id="beacon-rate-of-return-input"
                  value={amount}
                  min={'0'}
                  max={'25'}
                  format="^\d+\.?\d{0,4}$"
                  formatType="regexp"
                  name="rmd-calculator-rateofReturn"
                  onBeaconInput={(e) => {
                    const { target } = e;
                    document.getElementById(target.id).evaluateValidations();
                    if (target.value === '') setIsValidRate(true);
                    setAmount(target.value);
                  }}
                  onBeaconBlur={(e) => {
                    const { target } = e;
                    if (target.value === '') target.value = '0';
                    target.value < 0 || target.value > 25
                      ? setIsValidRate(false)
                      : setIsValidRate(true);
                    setAmount(target.value);
                  }}
                  errorsMap={{
                    max: 'Please enter a Rate of Return that is between 0 & 25%',
                  }}
                />
              </label>
              <button
                className={
                  isValidRate
                    ? styles['clickable-button']
                    : styles['clickable-button-2']
                }
                onClick={() => {
                  let num = parseFloat(amount) + 0.5;
                  if (num >= 25) num = 25;
                  setAmount(
                    Number((Math.floor(num * 10000) / 10000).toFixed(4))
                  );
                }}
              >
                <img
                  className={styles['lock-img']}
                  alt="plusBeacon"
                  src={plusBeacon}
                />
              </button>
            </div>
          </div>
        )}
        <div className={styles['rmd-calculate-acknowledge-container']}>
          <label>
            <div className={styles['rmd-acknowledge-container']}>
              <input
                type="checkbox"
                checked={isAcknowledge}
                onChange={(e) => setIsAcknowledge(!isAcknowledge)}
                className={styles['rmd-acknowledge']}
              />
              <span>
                I understand the RMD Calculator is intended to serve as an
                informational tool only, and should not be construed as legal,
                investment, or tax advice. I am responsible for calculating and
                withdrawing my RMD.
              </span>
            </div>
          </label>
          <div style={{ marginTop: '48px' }}>
            <button
              onClick={calculateMyRMd}
              className={`${styles['rmd-buttons-calculator']} ${
                disabledBtn && styles['disabled-calculate-btn']
              }`}
              disabled={disabledBtn}
            >
              Calculate My RMD
            </button>
            <button
              onClick={resetData}
              className={styles['rmd-buttons-calculator-not-filled']}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      <div className={styles['rmd-calculator']}>
        <div className={styles['rmd-calculator-amount-desc']}>
          <h2 className={styles['rmd-calculator-title']}>
            Your Required Minimum Distribution will be:
          </h2>
          <h3 className={styles['rmd-calculator-number']}>
            {currency(rmdDistribution?.[0]?.amount)}
          </h3>
          <div className={styles['rmd-calculator-tool-tip']}>
            <MyToolTip
              id={`rmd-calculation`}
              descriptionTitle={
                <p className={styles['rmd-poppper-title']}>
                  How your RMD was calculated
                </p>
              }
              descriptionBody={
                <div className={styles['rmd-desc-body']}>
                  <div className={styles['rmd-desc-left']}>
                    <div className={styles['rmd-year-end']}>
                      {showRMDCalc
                        ? currency(parseFloat(accountAsOf))
                        : 'Year End IRA Balance'}
                    </div>
                    <br />
                    <hr className={styles['rmd-divider']} />
                    <br />
                    <div className={styles['irs-lfe']}>
                      {showRMDCalc
                        ? rmdDistribution?.[0]?.factorAmount
                        : 'IRS Life Expectancy Factor'}
                    </div>
                  </div>
                  <div className={styles['rmd-desc-left']}>
                    <hr className={styles['rmd-equal']} />
                    <hr className={styles['rmd-equal']} />
                  </div>
                  <div className={styles['rmd-desc-left']}>
                    <div className={styles['irs-lfe']}>
                      {showRMDCalc
                        ? currency(rmdDistribution?.[0]?.amount)
                        : 'Required Minimum Distribution'}
                    </div>
                  </div>
                </div>
              }
              popOutPlacement="top"
              callerNode={DEFAULT_TRIGGER}
              maxNoteWidth="468px"
            />
          </div>
        </div>
        <div className={styles['prepare-future']}>
          {rmdDistribution && curDistributionType !== 'Prior' && (
            <h2 className={styles['prepare-future']}>
              Prepare for your future RMDs
            </h2>
          )}
          {rmdDistribution && curDistributionType !== 'Prior' && (
            <button
              className={styles['five-year-projection']}
              onClick={() => setShowProjection(!showProjection)}
            >
              {showProjection
                ? 'Hide 5 year projection'
                : 'Show 5 year projection'}
              <img
                className={styles['chevron-img']}
                alt="Chevron Toggle"
                src={showProjection ? chevronUp : chevronDown}
              />
            </button>
          )}
          {curDistributionType !== 'Prior' &&
            showProjection &&
            rmdDistribution && (
              <div className={styles['rmd-five-year-projection-table-con']}>
                <table className={styles['rmd-five-year-projection-table']}>
                  <tr>
                    <th>Year</th>
                    <th>Your age</th>
                    <th>Estimated RMD Amount</th>
                    <th>Estimated Account Balance</th>
                  </tr>

                  {rmdDistribution?.map((projection) => (
                    <tr key={projection.distributionYear}>
                      <td>{projection.distributionYear}</td>
                      <td>{Math.floor(projection.age)}</td>
                      <td>{currency(projection.amount)}</td>
                      <td>{currency(projection.estimatedBalance)}</td>
                    </tr>
                  ))}
                </table>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default CalculatorCalculation;
